module.exports = __webpack_public_path__ + "img/BackBodyNumbered.70809a97.png";